import { connect } from 'react-redux';

import AdobeAnalyticsModal from './components/AdobeAnalyticsModal';
import { PageTemplateReference } from './components/PageTemplateReference';
import { isProdEnvironment } from 'saga/appHandlers/ducks';

const SupportingTools = ({ isProdEnv }: StateToProps) => {
  return (
    <>
      {!isProdEnv && (
        <>
          <AdobeAnalyticsModal />
          <PageTemplateReference />
        </>
      )}
    </>
  );
};

interface StateToProps {
  isProdEnv?: boolean;
}

const mapStateToProps = (): StateToProps => ({
  isProdEnv: isProdEnvironment(),
});

export default connect(mapStateToProps, null)(SupportingTools);
